<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold politicas-modal-title">Política de entrega</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="modal-body pt-2 pb-1 politica-entrega-detalle-body">
    <div class="row g-3">
      <div class="col-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="politica-incoterms">Incoterms</label>
        <input
          id="politica-incoterms"
          type="text"
          class="form-control"
          formControlName="incoterms"
          readonly
        />
      </div>
      <div class="col-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="politica-comuna">Comuna</label>
        <input
          id="politica-comuna"
          type="text"
          class="form-control"
          formControlName="comuna"
          readonly
        />
      </div>
      <div class="col-4">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="politica-pallet">Pallet</label>
        <input
          id="politica-pallet"
          type="text"
          class="form-control"
          formControlName="pallet"
          readonly
        />
      </div>
      <div class="col-12">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="politica-horas">Horas</label>
        <input
          id="politica-horas"
          type="text"
          class="form-control"
          formControlName="horas"
          inputmode="numeric"
        />
        <div class="text-danger small mt-1" *ngIf="mensajeErrorHoras()">{{ mensajeErrorHoras() }}</div>
      </div>
      <div class="col-12">
        <label class="form-label fw-semibold text-uppercase small mb-1" for="politica-centro">Centro</label>
        <input id="politica-centro" type="text" class="form-control" formControlName="centro" />
        <div class="text-danger small mt-1" *ngIf="mensajeErrorCentro()">{{ mensajeErrorCentro() }}</div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-2 d-flex justify-content-end gap-2">
    <button
      *ngIf="puedeEliminar()"
      type="button"
      class="btn btn-outline-danger"
      [disabled]="loading"
      (click)="onDelete()"
    >
      Eliminar
    </button>
    <button type="submit" class="btn btn-success" [disabled]="loading">
      Guardar
    </button>
  </div>
</form>
